import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';

const HeroExpress = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={2}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '16vh',
          }}
        />

        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          variant="overline"
          color="textSecondary"
          align="center"
          display="block"
          gutterBottom
        >
          Propuesta Express
        </Typography>

        <Box
          component={Typography}
          fontWeight={700}
          variant="h3"
          gutterBottom
          align="center"
          color={theme.palette.primary.main}
          sx={{ px: 1 }}
        >
          DANIMAR x TNO Network
        </Box>

        <Typography
          variant="h6"
          component="p"
          color="textSecondary"
          align="center"
          sx={{ fontStyle: 'italic', mb: 1 }}
        >
          Presencia total: el estándar de la limpieza
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          align="center"
          sx={{ mb: 3, maxWidth: 680, mx: 'auto' }}
        >
          Entrada al ecosistema TNO: frecuencia en streaming, digest SEO y presencia web.
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          <Box
            component="img"
            src="/images/logodanimar.jpg"
            alt="Danimar"
            sx={{ width: 120, height: 120, objectFit: 'contain' }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </Box>

        <Box
          sx={{
            maxWidth: 720,
            mx: 'auto',
            py: 2,
            px: 2,
            borderRadius: 2,
            bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
          }}
        >
          <Typography variant="body1" color="textSecondary" align="center" paragraph>
            Propuesta de entrada pensada como un <strong>caballo de Troya</strong>: económica, muy efectiva por su
            frecuencia y con una estructura financiera cómoda para la marca. <strong>Danimar</strong> vive en todo el
            ecosistema de <strong>TNO Network</strong> de forma constante.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

HeroExpress.propTypes = {
  themeMode: PropTypes.string,
};

export default HeroExpress;
